import React, { type SVGProps } from 'react'

const WarningIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="47"
    viewBox="0 0 50 47"
    fill="none"
    {...props}
  >
    <path
      d="M24.8055 0C26.2296 0 27.5374 0.784688 28.2155 2.03437L49.1405 40.7844C49.7896 41.9856 49.7605 43.4387 49.063 44.6109C48.3655 45.7831 47.0964 46.5 45.7305 46.5H3.88049C2.51456 46.5 1.25518 45.7831 0.547992 44.6109C-0.159195 43.4387 -0.17857 41.9856 0.470493 40.7844L21.3955 2.03437C22.0736 0.784688 23.3814 0 24.8055 0ZM24.8055 16.275C23.5171 16.275 22.4805 17.3116 22.4805 18.6V29.45C22.4805 30.7384 23.5171 31.775 24.8055 31.775C26.0939 31.775 27.1305 30.7384 27.1305 29.45V18.6C27.1305 17.3116 26.0939 16.275 24.8055 16.275ZM27.3921 37.2C27.4502 36.2409 26.9755 35.3303 26.1521 34.8266C25.3286 34.3325 24.2921 34.3325 23.4686 34.8266C22.6452 35.3303 22.1705 36.2409 22.2286 37.2C22.1705 38.1591 22.6452 39.0697 23.4686 39.5734C24.2921 40.0675 25.3286 40.0675 26.1521 39.5734C26.9755 39.0697 27.4502 38.1591 27.3921 37.2Z"
      fill="currentColor"
    />
  </svg>
)

export default WarningIcon
